import { render, staticRenderFns } from "./CompanyOverview.vue?vue&type=template&id=86c32d9c&scoped=true&"
import script from "./CompanyOverview.vue?vue&type=script&lang=js&"
export * from "./CompanyOverview.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOverview.vue?vue&type=style&index=0&id=86c32d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c32d9c",
  null
  
)

export default component.exports